module.exports = __webpack_public_path__ + "img/portrait_640.fcf95716.webp";